import { render, staticRenderFns } from "./addPatient.vue?vue&type=template&id=0d322098&scoped=true"
import script from "./addPatient.vue?vue&type=script&lang=js"
export * from "./addPatient.vue?vue&type=script&lang=js"
import style0 from "./addPatient.vue?vue&type=style&index=0&id=0d322098&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d322098",
  null
  
)

export default component.exports